import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Grid } from '@mantine/core';
import { AuthHeader } from './components';

import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';

interface Props {
  leftColumn: ReactNode;
  rightColumn: ReactNode;
  classContainer?: string;
}

const AuthWrapper: FC<Props> = ({ leftColumn, rightColumn , classContainer }: Props): JSX.Element => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      <Grid id="main-wrapper" h={'100%'} className={classNames( styles.grid_container , classContainer  )} tabIndex={-1}>
        <AuthHeader />
        <Grid.Col className={classNames(styles.column, styles.left)} span={isMobile ? 12 : 6}>
          {leftColumn}
        </Grid.Col>
        <Grid.Col id="main-wrapper" className={styles.column} span={isMobile ? 12 : 6}>
          {rightColumn}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default AuthWrapper;
